import { createSelector } from '@reduxjs/toolkit';

export const selectFeatureFlagSlice = (state) => state.featureFlag;

export const selectSsoEnabled = createSelector([selectFeatureFlagSlice], (slice) => slice?.ssoenabled);
export const selectForgotPwdEnabled = createSelector([selectFeatureFlagSlice], (slice) => slice?.forgotPasswordEnabled);
export const selectKeycloakIntegrationEnabled = createSelector([selectFeatureFlagSlice], (slice) => slice?.keycloakIntegrationEnabled);